import DOMQuery from "../dom/DOMQuery";
export const select = (identifier, root = document) => {
    return new DOMQuery(identifier, root);
};
export const parentNodes = (fromElement, selector = undefined, root = document) => {
    const parents = [];
    let p = fromElement.parentNode;
    if (!p) {
        return [];
    }
    let o;
    let match;
    while (p !== root) {
        o = p;
        match = selector ? o.matches(selector) : true;
        match && parents.push(o);
        p = o.parentNode;
    }
    const rootElement = root;
    match = selector ? rootElement.matches(selector) : true;
    match && parents.push(rootElement);
    return parents;
};
export const onDomReady = function (callBack) {
    document.addEventListener('DOMContentLoaded', function (ev) {
        callBack(ev);
    });
};
export const getWindowDimensions = () => {
    const w = window, d = document, e = d.documentElement, b = d.body, x = w.innerWidth || e.clientWidth || b.clientWidth, y = w.innerHeight || e.clientHeight || b.clientHeight;
    return { width: x, height: y };
};
export const getElementSize = (element) => {
    const el = element;
    const width = el.offsetWidth || el.clientWidth;
    const height = el.offsetHeight || el.clientHeight;
    return { width, height };
};
const _globalContainerName = '_app_globals_';
export const defineGlobal = (varname, value) => {
    if (!window) {
        throw new Error('defineAsGlobal can only be used in a browser context');
    }
    const container = window[_globalContainerName] || {};
    container[varname] = value;
    window[_globalContainerName] = container;
};
export const getGlobal = (varname) => {
    if (!window) {
        throw new Error('getGlobal can only be used in a browser context');
    }
    const container = window[_globalContainerName] || {};
    return container[varname] || null;
};
;
